import { create } from "zustand";
import { api } from "../lib/api";

/**
 * Motivation / gamification store. Holds the current user's stats, level,
 * earned badges, and the badge catalog. Refresh on WS `motivation.update`.
 */
export const useMotivationStore = create((set, get) => ({
  stats: null,
  level: null,
  badges: [],
  catalog: [],
  loaded: false,

  async fetchMe() {
    try {
      const { data } = await api.get("/motivation/me");
      set({
        stats: data.stats,
        level: data.level,
        badges: data.badges,
        catalog: data.catalog,
        loaded: true,
      });
    } catch {
      set({ loaded: true });
    }
  },

  reset() {
    set({ stats: null, level: null, badges: [], catalog: [], loaded: false });
  },
}));
